import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useNotificationSubscription} from '../hooks/useNotificationSubscription';
import {NotificationSubscription} from '../types';
import {useParams} from 'react-router-dom';
import {useProduct} from '../../products/hooks/useProduct';
import {useEffect} from 'react';
import {PlatformLoader} from '@flexinet/ui-components';

export const AddFormDrawer = (props: DrawerProps) => {

    const {id: productId} = useParams();

    if (!productId) {
        throw new Error('productId is required parameter');
    }

    const {
        record: product,
        fetchRecord
    } = useProduct(productId);

    const {createRecord} = useNotificationSubscription();

    useEffect(() => {
        fetchRecord();
    }, []);

    if (!product) {
        return <PlatformLoader/>;
    }

    return (
        <FormDrawer
            record={{
                id: '',
                subscriptionArn: '',
                endpoint: '',
                protocol: '',
                topicArn: product.meteringServiceSnsTopicArn as string,
            } as unknown as NotificationSubscription}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
